const contactsRouter = [
  {
    path: '/contacts',
    name: 'ContactsIndex',
    component: () => import('@/views/contacts/index')
  },
  // {
  //   path: '/contacts/control',
  //   name: 'ContactsControl',
  //   component: () => import('@/views/contacts/control')
  // },
  {
    path: '/contacts/:id(\\d+)',
    name: 'ContactsDetail',
    component: () => import('@/views/contacts/detail')
  },
  {
    path: '/contacts/join_success',
    name: 'ContactsJoinSuccess',
    component: () => import('@/views/contacts/joinSuccess')
  },
  {
    path: '/contacts/view',
    name: 'ContactsView',
    component: () => import('@/views/contacts/view')
  },
  {
    path: '/contacts/ticket',
    name: 'ContactsTicket',
    component: () => import('@/views/contacts/ticket')
  },
  {
    path: '/contacts/invite',
    name: 'ContactsInvite',
    component: () => import('@/views/contacts/invite')
  },
  {
    path: '/contacts/ref',
    name: 'ContactsRef',
    component: () => import('@/views/contacts/ref')
  }
]

export default contactsRouter



// WEBPACK FOOTER //
// ./src/router/modules/contacts.js